var _mask, _g, _mask2, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMypageCash = function SvgMypageCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mypage-cash_svg__a",
    width: 16,
    height: 16,
    x: 1,
    y: 4,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.5 4.5h15v15h-15z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mypage-cash_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD167",
    fillRule: "evenodd",
    d: "M16.5 12a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mypage-cash_svg__b",
    width: 16,
    height: 16,
    x: 7,
    y: 4,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.5 4.5h15v15h-15z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mypage-cash_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF540E",
    fillRule: "evenodd",
    d: "M22.5 12a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.952 12.002q0-.682.264-1.3.262-.618.705-1.065a3.3 3.3 0 0 1 1.06-.713q.615-.265 1.29-.265.857 0 1.588.404.732.405 1.188 1.091l-1.314.918a1.8 1.8 0 0 0-.623-.597 1.65 1.65 0 0 0-.84-.224q-.72 0-1.22.51-.502.51-.501 1.241 0 .729.498 1.237.498.51 1.223.51.457 0 .844-.219.388-.219.628-.592l1.296.908q-.456.69-1.183 1.092a3.2 3.2 0 0 1-1.585.403q-.674 0-1.29-.266a3.3 3.3 0 0 1-1.059-.713 3.4 3.4 0 0 1-.705-1.067 3.3 3.3 0 0 1-.264-1.293",
    clipRule: "evenodd"
  })));
};
export default SvgMypageCash;